const state = {
}

const getters = {}

const actions = {
  getCustomer ({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios
        .get("/customers", {params: params})
        .then(response => {resolve(response.data)})
        .catch ( error => (reject(error)));
    })
  }
}

const mutations = {
  setCustomer (state, data) {
    state.customer = data;
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
